export const WATCHLIST_STORAGE_KEY = "watchlist";
export const GUEST_WATCHLIST_LIMIT = 3;
